import AsyncSelect from "react-select/async";
import AsyncCreatableSelect from "react-select/async-creatable";

export function DropdownAsync({
	label,
	fetchOptions,
	defaultOptions,
	defaultValue,
	onChange,
	disabled,
	isError,
	isCreatable,
	// Allow overrides but provide safe defaults to avoid clipping inside tables
	menuPortalTarget = typeof document !== "undefined" ? document.body : undefined,
	menuPosition = "fixed",
	menuShouldBlockScroll = true,
	...props
}) {
	const BaseSelect = isCreatable ? AsyncCreatableSelect : AsyncSelect;

	const filterDatas = (data, inputValue) => {
		return data.filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()));
	};

	const loadOptions = (inputValue, callback) => {
		if (inputValue.length === 0) {
			callback([]);

			return;
		}

		if (typeof fetchOptions === "function")
			fetchOptions(inputValue, data => callback(filterDatas(data ?? [], inputValue)));
	};

	return (
		<BaseSelect
			{...props}
			components={{
				IndicatorSeparator: () => null,
			}}
			defaultOptions={defaultOptions}
			defaultValue={defaultValue}
			isDisabled={disabled}
			loadOptions={loadOptions}
			menuPortalTarget={menuPortalTarget}
			menuPosition={menuPosition}
			menuShouldBlockScroll={menuShouldBlockScroll}
			placeholder={label}
			styles={{
				control: baseStyles => ({
					...baseStyles,
					borderColor: isError ? "#f21a1a" : "#e8e8e8",
					minHeight: 50,
					paddingTop: 6,
					paddingBottom: 6,
					zIndex: 1,
					boxShadow: "none",
					"&:hover": {
						borderColor: isError ? "#f21a1a" : "#e8e8e8",
					},
					"&:focus-within": {
						borderColor: "#45969b",
					},
				}),
				menu: base => ({
					...base,
					zIndex: 6,
				}),
				menuPortal: base => ({
					...base,
					zIndex: 10000,
				}),
				multiValue: base => ({
					...base,
					backgroundColor: "#FFF7E1",
					color: "#F36E21",
				}),
				multiValueLabel: base => ({
					...base,
					color: "#F36E21",
				}),
				multiValueRemove: base => ({
					...base,
					"&:hover": {
						backgroundColor: "rgba(243, 110, 33, 0.05)",
					},
				}),
				dropdownIndicator: baseStyles => ({
					...baseStyles,
					color: "#f36e21",
				}),
			}}
			onChange={onChange}
		/>
	);
}
